'use strict global window';

/* global grecaptcha, tok_gen */

export default function() {
  // Instantiate the alertContainer variable.
  var alertContainer;

  var privacyPolicyAcceptCheckbox = document.getElementById('privacyPolicyAccept');

  if (document.body.contains(document.getElementById('privacyPolicyAccept'))) {
    $('#SubmitContactUsBtn').addClass('disabled');
    $('#SubmitContactUsBtn').attr('disabled', true);

    privacyPolicyAcceptCheckbox.addEventListener('change', (e) => {
      if (e.target.checked) {
        $('#SubmitContactUsBtn')
          .removeClass('disabled')
          .attr('disabled', false);
      } else {
        $('#SubmitContactUsBtn')
          .addClass('disabled')
          .attr('disabled', true);
      }
    });
  }

  // Test for honeypot
  // Add the validation method for jQuery validate
  $.validator.addMethod('hp_input', function(value) {
    // Test to make sure that the honeypot is empty.
    if (value === '' || value === null) {
      return true;
    } else {
      return false;
    }
  });

  // Make sure that we test for US in the if block.
  // Other markets will be tested in the else block.
  if (window.locale === 'en_US') {
    // US Zipcode & Phone numbers must adhere to the Regular Expressions below.
    var zipCodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
    var phoneNumberRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

    // Add validator method for US zipcode
    $.validator.addMethod('zipCode', function(value, element) {
      return this.optional(element) || zipCodeRegex.test(value);
    });

    // Add validator method for US phone numbers
    $.validator.addMethod('phoneNumber', function(value, element) {
      return this.optional(element) || phoneNumberRegex.test(value);
    });
  } else {
    // Add validator method for global zipcodes
    $.validator.addMethod('zipCode', function() {
      return true;
    });

    // Add validator method for global phone numbers
    $.validator.addMethod('phoneNumber', function() {
      return true;
    });
  }

  // Emails must adhere to the Regular expression below
  var emailRegex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}/;

  // Add the validator method for emails
  $.validator.addMethod('email', function(value, element) {
    return this.optional(element) || emailRegex.test(value);
  });

  // Add the validator method for the captcha
  $.validator.addMethod('captcha', function() {
    $('SubmitContactUsBtn').attr('disabled', 'disabled');

    // First, we need to test to make sure that we have our toggle set
    // Then, we must test to see if out token is valid or not
    // This returned value sets the truth of the validator for captcha
    if (tok_gen.reCaptchaTokenToggle === true) {
      // Expected value true or false
      return tok_gen.tokenValid;
    } else {
      return true;
    }
  });

  // jQuery validate block
  // To reference this documentation go to:
  // https://jqueryvalidation.org/
  $('#ContactUsForm').validate({
    // Set the rules that we want to test
    rules: {
      // First Name
      powf_e056335033f7e811a94a000d3a34ebb5: {
        required: true,
      },
      // Last Name
      powf_e156335033f7e811a94a000d3a34ebb5: {
        required: true,
      },
      // Zip Code
      powf_e256335033f7e811a94a000d3a34ebb5: {
        required: true,
        zipCode: true,
      },
      // Email
      powf_e356335033f7e811a94a000d3a34ebb5: {
        required: true,
        email: true,
      },
      // Topic
      powf_e456335033f7e811a94a000d3a34ebb5: {
        required: true,
      },
      // Questions
      powf_e656335033f7e811a94a000d3a34ebb5: {
        required: true,
      },
      // reCAPTCHA
      captcha: {
        required: true,
      },
      // Honeypot
      hp_input: {
        required: true,
      },
    },

    invalidHandler: function() {
      // If there are any errors, then scroll to the top of the form and show the
      // list of errors.
      $('html, body').animate({
        scrollTop: $('.title_holder').offset().top - 150,
      });
    },

    // contactus_messages are defined in ContactUsForm.jsp
    // Located: hybris/bin/custom/trek/trekstorefront/web/webroot/WEB-INF/views/desktop/cms/contactusform.jsp
    messages: contactus_messages,

    // If we have any errors we need to fire this function
    errorPlacement: function(error, element) {
      // Since the .jsp has to different areas for the alerts to show,
      // we need to make sure that if the confirmation page is active we
      // only submit the alerts to the globalMessages container
      if ($('#globalMessages .alert').length) {
        alertContainer = $('#globalMessages .alert');
      } else {
        alertContainer = $('#ContactUsErrors.alert');
      }

      if (error[0] && error[0].innerHTML !== '') {
        // show the alert dialog its hidden by default
        alertContainer.removeClass('hide');

        // add the error styles to the form field
        $(element)
          .parent()
          .parent()
          .addClass('form__item--error alert-icon-after');

        var errorLabel = alertContainer.find('#' + error[0].id);

        if (!errorLabel || errorLabel.length === 0) {
          // place the error message in the alert div.
          error.appendTo(alertContainer);
        }
      } else {
        $(element)
          .parent()
          .parent()
          .removeClass('form__item--error')
          .removeClass('alert-icon-after');
      }
    },

    // Set to false so the validation happens on submission
    onfocusout: false,
    // Set to false so the validation happens on submission
    onkeyup: false,
    // Set to false so the validation happens on submission
    onclick: false,
    // This method fires when we have a successful validation
    success: function(label) {
      // Set the alertContainer variable for when we are on the confirmation
      // of the form, this allows us to remove the error messages in the correct
      // location
      if ($('#globalMessages .alert').length) {
        alertContainer = $('#globalMessages .alert');
      } else {
        alertContainer = $('#ContactUsErrors.alert');
      }

      // remove the correct error messages
      alertContainer.find('#' + label[0].id).remove();

      // Push our data to Google Analytics data layer
      ACC.track.pushToDataLayer({
        event: 'contact-us',
        Action: 'Contact Us Submitted',
        Category: 'Contact Us',
      });
    },
  });

  // This is the event handler for the submit button
  $('#SubmitContactUsBtn').on('click', function(e) {
    // Prevent the initial subission of the form
    e.preventDefault();

    // Test for the toggle
    // if the toggle is true then we will submit an
    // AJAX request to verify the token
    if (tok_gen.reCaptchaTokenToggle === true) {
      // grab the securitycode value to test the token
      // var value = tok_gen.recaptchaToken;
      submitToken();
    } else {
      // When the toggle is false we will simply submit the form
      submitForm();
    }
  });

  // Here is a simple submission method where
  // we test to make sure that the form is valid
  // prior to submitting the form
  function submitForm() {
    if ($('#ContactUsForm').valid() === true) {
      $('#ContactUsForm').submit();
    }
  }

  // Success method for AJAX call in the SubmitContactUsBtn event.
  function tokenSuccess(data) {
    // Set the token valid object for validator method
    tok_gen.tokenValid = false;

    if (data === true) {
      // Set the token valid object for validator method
      tok_gen.tokenValid = true;
      // call the method for setting the token for the back end
      submitForm();
    } else {
      // Handle when we have an error for the token
      // Set the message that will be shown when there is an error for
      // the captch validator method
      $.validator.messages.captcha = contactus_messages.invalidsecuritycode;
      // if we have a token failure we redirect.
      $('#ContactUsErrors').removeClass('hide');

      $('html, body').animate({
        scrollTop: $('.title_holder').offset().top - 150,
      });
    }
  }

  // Resubmit method for token generation call in tokenSuccess method.
  function submitToken() {
    // Test that the method of calling a token is ready per Google's docs
    grecaptcha.ready(function() {
      // Execute the function to generate the token
      grecaptcha
        .execute(tok_gen.reCaptchaSiteKey, {
          action: 'contactUs',
        })
        .then(function(token) {
          // Set the token valid object for validator method
          tok_gen.tokenValid = true;

          // Submit the token for validation
          $.ajax({
            type: 'GET',
            dataType: 'json',
            url: '/recaptcha/verify?token=' + token,
            success: tokenSuccess, // on success fire the tokenSuccess method below
            error: tokenError, // on error fire the tokenError method below
          });
        });
    });
  }
  // Method declaration for handling a token error.
  function tokenError() {
    // Set the message that will be shown when there is an error for
    // the captch validator method
    $.validator.messages.captcha = contactus_messages.invalidsecuritycode;
    // Return false for the validation rule
    return false;
  }

  // this function clears the alerts when the button is clicked so ones that
  // are resolved no longer show as an error
  $('[data-clear-form]').click(function() {
    alertContainer.empty();

    $('#powf_EEFA8C8C08D3E41180CE00155D477A56')
      .children()
      .children()
      .children('li')
      .removeClass('form__item--error alert-icon-after');
  });
}
